






import {
  Component,
  Vue
} from "vue-property-decorator";
import { cardsData } from '@/static/dashboardCardData';
import DashboardCard from '@/components/DashboardCard/DashboardCard.vue';

@Component({
  components: {
    DashboardCard,
  },
})
export default class Dashboard extends Vue {
  public cardsData = cardsData
}
